import {computed} from 'vue';

export function getCookieValue(cookieName: string): string {
  const cookies = document.cookie.split(';').map((c) => c.trim());

  const cookie = cookies.find((c) => c.startsWith(`${cookieName}=`));

  if (!cookie) {
    return '';
  }

  return cookie.split('=')[1];
}

export function useCookieConsentRef(cookieName: string) {
  return computed<boolean>(() => {
    const cookieValue = getCookieValue('stemble_cookie_consent');
    if (!cookieValue) {
      return false;
    }
    try {
      const consentData = JSON.parse(decodeURIComponent(cookieValue));
      return consentData[cookieName] === true;
    } catch (e) {
      return false;
    }
  });
}
